import { createContext } from 'react';

export const LanguageContext = createContext(
  /** @type {LanguagesShort} */ ('de'),
);

export const LanguageProvider = LanguageContext.Provider;
export const LanguageConsumer = LanguageContext.Consumer;
